import {FC} from 'react'

import {ColumnSkeleton} from 'components'
import classNames from 'classnames'

/**
 * A generic skeleton component for page loading states.
 * Typically used for pages that include a left-side navigation.
 */
interface PageLoadingSkeletonProps {
  dataCy?: string
  classes?: string
}
export const PageLoadingSkeleton: FC<PageLoadingSkeletonProps> = ({
  dataCy,
  classes,
}) => {
  return (
    <div
      data-cy={dataCy}
      // Phones: one column, with bars that shrink to the screen.
      className={classNames(
        'relative grid grid-cols-14 h-full mobile:block',
        classes,
      )}
    >
      <section className="col-span-10 py-6 pl-6 pr-4 mobile:px-5">
        <div className="flex justify-between mobile:flex-col mobile:gap-3">
          <ColumnSkeleton width={400} classes="mobile:max-w-full" />
          <ColumnSkeleton width={150} />
        </div>

        <ColumnSkeleton
          width={350}
          height={8}
          classes="mt-8 mobile:max-w-full"
        />
        <ColumnSkeleton
          width={300}
          height={8}
          classes="mt-4 mobile:max-w-full"
        />
        <ColumnSkeleton width={250} height={8} classes="mt-4" />
      </section>
      <section className="col-span-4 p-6 border-l-0.5 border-gray-400 mobile:hidden">
        <ColumnSkeleton width={150} />
      </section>
    </div>
  )
}
